import React from 'react';
import { withRouter } from 'react-router-dom';
import { AppInsights } from 'applicationinsights-js';
import { connect } from 'react-redux';

// Setup ApplicationInsights 
const useApplicationInsights = process.env.REACT_APP_ApplicationInsightsKey !== undefined;
if (useApplicationInsights) {
    AppInsights.downloadAndSetup({ instrumentationKey: process.env.REACT_APP_ApplicationInsightsKey});
}

// handles route changes
class ApplicationInsights extends React.Component {
    constructor(props) {
        super(props);

        AppInsights.trackPageView(window.location.pathname);

        this.props.history.listen((location, action) => {
            if (useApplicationInsights)
                AppInsights.trackPageView(location.pathname);
        });
    }

    componentWillReceiveProps(nextProps) {
        const { isRealtor, userName } = nextProps;

        // If isRealtor didn't change no need to re-initialize
        if (isRealtor === this.props.isRealtor) return;

        AppInsights.setAuthenticatedUserContext(userName);
    }

    render() {
        return null;
    }
}

const mapStateToProps = (state, props) => {
    return {
        isRealtor: state.profile.mine == null ? null : state.profile.mine.Realtor,
        userName: state.profile.mine == null ? null : state.profile.mine.Username
    }
}

export default withRouter(connect(mapStateToProps)(ApplicationInsights));

// handles tab clicks
export const pageView = (pathname) => {
    if (useApplicationInsights)
        AppInsights.trackPageView(pathname);
}